// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataCategoryItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import OverflowText from 'share/components/controls/Izenda.OverflowText';

/**
 * DataCategoryItem component
 */
const DataCategoryItem = props => {
  const { localization, isCollapsed, collapseToggle, dataSource } = props;

  const categoryName = dataSource.name || localization.getText('COMMON_LABEL_UNCATEGORIZED');
  const iconClass = isCollapsed ? 'icon-folder-close' : 'icon-folder-open';

  return (
    <OverflowText onClick={collapseToggle} text={categoryName} className="selectable" tooltip={categoryName}>
      <i className={iconClass} />
      {categoryName}
    </OverflowText>
  );
};

DataCategoryItem.displayName = 'DataCategoryItem';

export default connect()(DataCategoryItem);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSourceTree/Izenda.DataCategoryItem.js